import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Layout, Card } from 'tea-component';
import { omit, isEmpty } from 'lodash-es';
import { useHistory, useIntl, useParams } from 'umi';
import moment from 'moment';
import { useSafeState, useSetState, useUpdate } from 'ahooks';
import StreamingKolEcahrts from './components/KolEcahrts';
import StreamingKolTableList from './components/KolTableList';
import StreamingKoLFilter from './components/Sizer';
import useFilterOptions from '../hooks/useFilterOptions';
import { cleanObject } from '../../../GlobalView/MarketSize/hooks/useQuery';
import { TOP_COMPANIES_NUM } from '../../../TopCharts/_config/topChartsConst';
import {
  DOMAINS_CONFIGS,
  getPlatfromParms,
  getKolDetailDbiPageLogMes,
  PLATFROM_VALUE_LIST,
} from '../utils';
import '@/pages/intelligence/assets/scss/Streaming/kolDetails.scss';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useEarliesTimeHasData from '@/pages/intelligence/hooks/useEarliesTimeHasData';
import { hasDataTimerParams } from '@intelligence/utils/timerDefautParams';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';

const { Body, Content } = Layout;
// 上个月的前一天
export const lastMonth = moment().subtract(1, 'month').format('YYYY-MM-DD');
// 当月前2天
export const currentMonth = moment().subtract(1, 'day').format('YYYY-MM-DD');
const KolDetails = () => {
  const history = useHistory();
  const { formatMessage } = useIntl();
  const active = useParams() as any;
  const { isOperateDetail, detailFilterExtend, resetDetailFilterExtend } = useFilterExtend({});

  const { latestTimeTypeHasData } = useEarliesTimeHasData({
    filterType: hasDataTimerParams?.streamingInfluencerDetail?.type,
  });

  const platfromValueList = useMemo(() => {
    return getPlatfromParms(active?.tab) || PLATFROM_VALUE_LIST;
  }, [active?.tab]);

  const pageKey = useMemo<string>(() => {
    const config = DOMAINS_CONFIGS?.[active?.tab] || '';
    const key = getKolDetailDbiPageLogMes(config);
    return key || '';
  }, [active?.tab]);

  const getExtendParams = () => {
    const newFetchParams: any = {};
    const timeExtend = detailFilterExtend[filterKeyMap.RANGE_TIME];
    if (timeExtend) {
      newFetchParams.period = timeExtend?.granularity || 'daily';
      newFetchParams.start_date = timeExtend?.start_date || '';
      newFetchParams.end_date = timeExtend?.end_date || '';
    }
    return newFetchParams;
  };
  const extendParams = isOperateDetail ? getExtendParams() : {};

  // common默认参数,当common默认参数变化的时候，整个页面将会render
  const [paramsDefault, setParamsDefault] = useSetState<{
    [key in string]: unknown;
  }>({
    ratio_type: 0,
    order: 'desc',
    platfrom: platfromValueList,
    market: [],
    language: [],
    start_date: extendParams.start_date || '',
    end_date: extendParams.end_date || '',
    period: extendParams.period || 'daily',
    page: 1,
    page_size: 100,
    // 折线接口， =1会把柱状的也返回
    chart_type: 1,
    genre_source: '',
    iegg_genre_req: [],
  });
  // 表格纽带
  const intableRef = useRef<HTMLDivElement>();
  // 筛选器数据
  const { headQuatersOptionsData, regionsOptions } = useFilterOptions();
  const updata = useUpdate();
  // 这个参数不像TopCharts模块，可以直接往图表数据进行push,不进行接口拉取,需要根据传入的userIds进行report,
  const [userIds, setUserIds] = useSafeState({
    addNumber: TOP_COMPANIES_NUM,
    userList: [],
  });
  useEffect(() => {
    updata();
  }, [intableRef.current?.dateTimes]);

  const [tableLoading, setTableLoading] = useState(true);

  // body头部title
  const title = useMemo(() => {
    const config = DOMAINS_CONFIGS?.[active?.tab] || '';
    const mesKey = getKolDetailDbiPageLogMes(config);
    buriedPointPage(dbiPageLogMes[mesKey]);
    return `${config} ${formatMessage({ id: 'dbi_Primary_kol' })}`;
  }, [active?.tab, formatMessage]);

  // 筛选器submit
  const handleConfirm = (value) => {
    /*
    const {
      start_date,
      end_date,
      date_type: period,
      iegg_genre_req: iegg_genre_reqs,
      isDiffIeggLength,
      ...restProps
    } = value;
    */
    intableRef.current?.ecahrtsIsRefresh();
    setParamsDefault({
      ...paramsDefault,
      ...value,
      page: 1,
      /*
      start_date,
      end_date,
      period,
      page: 1,
      iegg_genre_req: isDiffClearArr(iegg_genre_reqs, isDiffIeggLength),
      ...omit(cleanObject(restProps), ['isDiffIeggLength']),
      */
    });
  };
  // 筛选器reset
  const handleReset = (value) => {
    // console.log(value);
  };

  return (
    <Layout className="dbi-kol-details">
      <Body>
        <Content>
          <Content.Header
            showBackButton
            onBackButtonClick={() => {
              resetDetailFilterExtend();
              history.goBack();
            }}
            title={title}
          />
          <Content.Body full>
            <MarqueeBanner />
            <Card>
              <Card.Body>
                <StreamingKoLFilter
                  headQuatersOptionsData={headQuatersOptionsData}
                  regionsOptions={regionsOptions}
                  timeFilterValues={{
                    type: paramsDefault?.period,
                    value: [
                      !isEmpty(paramsDefault?.start_date)
                        ? moment(paramsDefault?.start_date)
                        : moment(intableRef.current?.dateTimes?.[0]),
                      !isEmpty(paramsDefault?.end_date)
                        ? moment(paramsDefault?.end_date)
                        : moment(intableRef.current?.dateTimes?.[1]),
                    ],
                  }}
                  filterConfirm={handleConfirm}
                  filterReset={handleReset}
                  filterInit={() => {}}
                  rangeTimeComponentDefault={latestTimeTypeHasData}
                  platfromValueList={platfromValueList}
                />
              </Card.Body>
            </Card>
            <StreamingKolEcahrts
              {...{
                paramsDefault,
                userIds,
                loading: tableLoading,
                dateTimes: intableRef.current?.dateTimes,
                sortTextKeys: intableRef.current?.sortTextKeys,
              }}
            />
            <StreamingKolTableList
              intableRef={intableRef}
              setTableLoading={setTableLoading}
              downloadLogConfigKey={`${pageKey}DownloadExcel`}
              {...{
                paramsDefault,
                setParamsDefault,
                setUserIds,
                userIds,
              }}
            />
          </Content.Body>
        </Content>
      </Body>
    </Layout>
  );
};

export default KolDetails;
